export enum SHIPPING_PERMISSIONS {
  SHIPPING_VIEW = 'SHIPPING_VIEW',
  SHIPPING_WRITE = 'SHIPPING_WRITE',
}
